import React, { useState, useEffect, setState } from "react";
import { Routes, Route } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { IntlProvider } from "react-intl";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import axios from "axios";
import Spanish from "../lang/es.json";
import English from "../lang/en.json";
import Home from "./Home";
import Ring from "./Ring";
import RingDetail from "./RingDetail";
import Qr from "./Qr";
import QrRaw from "./QrRaw";
import NoMatch from "./NoMatch";
import Login from "./Login";
import SignupForm from "./SignupForm";
import Account from "./Account";
import Terms from "./Terms";
import Privacy from "./Privacy";
import Help from "./Help";
import Map from "./Map";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

axios.defaults.withCredentials = true;

const locales = ["es", "es-ar", "es-es"];
let locale;
let lang;

const App = () => {
  locale = navigator.language.toLowerCase();
  if (locales.includes(locale)) {
    lang = Spanish;
  } else {
    lang = English;
  }

  const [user, setUser] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState(null);

  const updateUserState = (payload) => {
    setUser(payload);
  };
  const updateBreadcrumbsState = (object) => {
    setBreadcrumbs(object);
  };

  // useEffect hook with an empty dependency array means this effect will only run once, like componentDidMount
  useEffect(() => {
    getUser();
  }, []);

  const getUser = () => {
    if (!user) {
      axios
        .get("/api/test/user/")
        .then((response) => {
          if (response.data.id) {
            updateUserState(response.data);
          }
        })
        .catch((error) => {
          updateUserState(null);
        });
    }
    return user;
  }

  locale = user ? user.locale : navigator.language.toLowerCase();
  if (locales.includes(locale)) {
    lang = Spanish;
  } else {
    lang = English;
    locale = "en";
  }

  return (
    <AppContext.Provider value={{ user, updateUserState, updateBreadcrumbsState, breadcrumbs }}>
      <IntlProvider locale={locale} messages={lang}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/signup" element={<SignupForm />} />
            <Route exact path="/account" element={<Account />} />
            <Route exact path="/qrraw" element={<QrRaw />} />
            <Route exact path="/terms" element={<Terms />} />
            <Route exact path="/privacy" element={<Privacy />} />
            <Route exact path="/help" element={<Help />} />
            <Route exact path="/map" element={<Map />} />
            <Route exact path="/ring/" element={<Ring />} />
            <Route exact path="/ring/:ringId" element={<RingDetail />} />
            <Route exact path="/qr/:qrCode" element={<Qr />} />
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </LocalizationProvider>
      </IntlProvider>
    </AppContext.Provider>
  );
};

export default App;
